module.exports = __webpack_public_path__ + "static/media/cutsglare_tradchinese_00205.1463b381.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/tc/cutsglare_tradchinese_00205.png
// module id = 3327
// module chunks = 0